import React from "react";
import PendingApprovals from "../../molecules/PendingApprovals/PendingApprovals";
import { PendingApprovalProps } from "../../molecules/PendingApprovals/types";

/**
 * @author
 * @function @
 **/

export const PendingApprovalRequests: React.FC<PendingApprovalProps> = ({
  count,
  label = "Pending Approvals",
  onClick,
}) => {
  return <PendingApprovals count={count} label={label} onClick={onClick} />;
};
